// Знакова конвенция на процента по сметка (bill.discount_percent):
// положителен = отстъпка на клиент, отрицателен = надбавка, null = без
// клиент (0 е валиден клиент с 0%). BE прилага
// price × (100 − percent) / 100 върху всеки нов ред (заключените цени се
// прескачат) — виж bills/service.py. Споделено между двата екрана на
// „Маркиране" (ClientsModal, каталога и прегледа на поръчката).

/** „−X%" за отстъпка / „+X%" за надбавка / „0%" без знак за клиент с 0%. */
export const formatSignedBillPercent = (percent: number): string =>
  percent === 0
    ? "0%"
    : percent < 0
      ? `+${Math.abs(percent)}%`
      : `-${percent}%`;

/** Единична цена след процента по сметката (BE формулата). */
export const applyBillPercentToPrice = (
  price: number,
  percent: number,
): number => (price * (100 - percent)) / 100;
